import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FaTrash, FaEdit } from 'react-icons/fa';
import Sidebar from '../component/Sidebar';
import MobileHeaderToggle from "../component/MobileHeaderToggle";
import Pagination from "../Master/Pagination";


const DesignationList = () => {
  const PER_PAGE_STORAGE_KEY = "designationList.perPage";
  const getStoredPerPage = () => {
    const raw = localStorage.getItem(PER_PAGE_STORAGE_KEY);
    if (!raw) return 20;
    if (raw === "all") return "all";
    const num = Number(raw);
    return Number.isFinite(num) && num > 0 ? num : 20;
  };

  const [designations, setDesignations] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("ALL");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(getStoredPerPage);
  const navigate = useNavigate();
  const goBack = () => navigate(-1);

  const fetchDesignations = async () => {
    try {
      const res = await axios.get('/api/designations');
      console.log('Fetched designations:', res.data); // ✅ Debug
      setDesignations(res.data);
    } catch (err) {
      console.error('Fetch Designations Error:', err);
    }
  };

  useEffect(() => {
    fetchDesignations();
  }, []);

  useEffect(() => {
    localStorage.setItem(PER_PAGE_STORAGE_KEY, String(perPage));
  }, [perPage]);

  const departments = ["ALL", ...new Set(designations.map(d => d.departmentName))];
//  Filter by Department
const filteredDesignations =
  selectedDepartment === "ALL"
    ? designations
    : designations.filter(d => d.departmentName === selectedDepartment);

// Pagination on filtered data
const indexOfLast =
  perPage === "all"
    ? filteredDesignations.length
    : currentPage * perPage;

const indexOfFirst =
  perPage === "all"
    ? 0
    : indexOfLast - perPage;

const currentdesignations =
  perPage === "all"
    ? filteredDesignations
    : filteredDesignations.slice(indexOfFirst, indexOfLast);

  const deleteDesignation = async (id) => {
    if (!window.confirm('Are you sure you want to delete this designation?'))
      return;
    try {
      await axios.delete(`/api/designations/${id}`);
      setDesignations(designations.filter((d) => d._id !== id));
    } catch (err) {
      console.error(err);
    }
  };

  return (
  <div className="flex h-screen flex-col md:flex-row">
      <Sidebar/>
    <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
    <div className="flex-1 flex flex-col min-h-0 p-3 bg-white shadow-md rounded-md">
      <MobileHeaderToggle>
      <div className="bg-dorika-blueLight border border-blue-300 rounded-lg shadow-md p-2 mb-1 flex justify-between items-center">
        <h2 className="text-xl font-bold text-dorika-blue whitespace-nowrap">
          Designation
        </h2>
        <button
          type="button"
          onClick={goBack}
          className="h-8 px-3 rounded bg-dorika-blue text-white font-semibold text-sm hover:bg-dorika-orange"
        >
          Back
        </button>
      </div>

<div className="bg-dorika-blueLight p-3 rounded-lg shadow mb-3 border border-dorika-blue">
<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 items-end">

  <div className="flex flex-col w-full">
    <label className="font-semibold text-dorika-blue text-xs uppercase mb-1">
      Department
    </label>
    <select
      value={selectedDepartment}
      onChange={(e) => {
        setSelectedDepartment(e.target.value);
        setCurrentPage(1);
      }}
      className="w-full h-8 border border-dorika-blue rounded px-3 text-sm bg-white font-semibold text-dorika-blue"
    >
      {departments.map((dep, index) => (
        <option key={index} value={dep}>
          {dep}
        </option>
      ))}
    </select>
  </div>

  {/* Show Dropdown */}
  <div className="flex flex-col w-full">
    <label className="font-semibold text-dorika-blue text-xs uppercase mb-1">
      Show
    </label>
    <select
      value={perPage}
      onChange={(e) => {
        const val = e.target.value;
        setPerPage(val === "all" ? "all" : parseInt(val));
        setCurrentPage(1);
      }}
      className="w-full h-8 border border-dorika-blue rounded px-3 text-sm bg-white font-semibold text-dorika-blue"
    >
      <option value={20}>20</option>
      <option value={30}>30</option>
      <option value={50}>50</option>
      <option value={100}>100</option>
      <option value="all">ALL</option>
    </select>
  </div>

  <div className="flex flex-col w-full">
    <label className="font-semibold text-dorika-blue text-xs uppercase mb-1">
      Action
    </label>
    <button
      onClick={() => navigate('/designationMaster')}
      className="w-full h-8 bg-dorika-orange hover:bg-dorika-blue text-white px-3 sm:px-4 rounded font-semibold text-sm whitespace-nowrap"
    >
      Add Designation
    </button>
  </div>

</div>
</div>
      </MobileHeaderToggle>

      <div className="w-full flex-1 min-h-0 overflow-auto mt-2">
      <table className="w-full table-auto border border-dorika-blue">
        <thead className="bg-dorika-blue text-white text-sm sticky top-0 z-10">
          <tr>
            <th className="border border-dorika-blue px-2">SL No</th>
            <th className="border border-dorika-blue px-2">Designation ID</th>
            <th className="border border-dorika-blue px-2">Designation Name</th>
            <th className="border border-dorika-blue px-2">Department</th>
            <th className="border border-dorika-blue px-2">Grade</th>
            <th className="border border-dorika-blue px-2">Status</th>
            <th className="border border-dorika-blue px-2">Action</th>
          </tr>
        </thead>
        <tbody className="text-xs sm:text-sm text-center">
          {designations.length > 0 ? (
           currentdesignations.map((d,index) => (
              <tr key={d._id} className="hover:bg-dorika-blueLight transition">
                <td className="border border-dorika-blue px-2 py-1">
                  {perPage === "all" ? index + 1 : (currentPage - 1) * perPage + index + 1}
                </td>
                <td className="border border-dorika-blue px-2">{d.designationID}</td>
                <td className="border border-dorika-blue px-2">{d.designationName}</td>
                <td className="border border-dorika-blue px-2">{d.departmentName}</td>
                <td className="border border-dorika-blue px-2">{d.grade}</td>
                <td className="border border-dorika-blue px-2">{d.status}</td>
                <td className="border border-dorika-blue px-2 ">
                <div className="flex justify-center gap-4 sm:gap-8">
                    <button
                    onClick={() =>
                      navigate('/designationMaster', { state: { designation: d } })
                    }
                    className="text-dorika-blue hover:text-dorika-green"
                  >
                    <FaEdit />
                  </button>
                  <button
                    onClick={() => deleteDesignation(d._id)}
                    className="text-dorika-orange hover:text-red-700"
                  >
                    <FaTrash />
                  </button>
                </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center py-4 text-gray-500">
                No designations found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {perPage !== "all" && (
        <Pagination
          total={designations.length}
          perPage={perPage}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
      )}
    </div>
</div>
</div>
</div>
  );
};

export default DesignationList;

